import React from "react";
import { Typography, Stack } from "@mui/material";
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';

export default function UnderConstruction () {
	return <Stack gap={2} justifyContent="center" alignItems="center" flexDirection="row" sx={{ flexGrow: 1, minHeight: 300 }}>
		<ConstructionRoundedIcon sx={{ fontSize: 60 }}/>
		<Typography fontSize="30px" fontWeight={600}>This Page is Under Construction</Typography>
	</Stack>
}